<script>
const { inject } = require('vue')

export default {
  name: 'LocalizableComponent',
  data() {
    return {
      featureToggles: inject('$featureToggles'),
      ft: inject('$ft')
    }
  }
}
</script>
